<template> <!-- 勤務時間コンポーネント(子) -->
  <div id="dailywork">
    <p style="margin-bottom: 3px; width: 60px; padding-top: 10px; text-align:center;">
      <span>{{ total[index] }}</span>
      <input type="hidden" :value="total[index]" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'DailyWork',
  data () {
    return {
    }
  },
  props: {
    monthDay: Array,
    index: Number,
    total: Array
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
